/**
 * Per-device unique ID, persisted in localStorage.
 * Used for likes/views/owner detection. No PII, no account.
 */

const KEY = 'guestlens_device_id';

export function getDeviceId(): string {
  if (typeof window === 'undefined') return '';
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(KEY, id);
  }
  return id;
}
